export enum AppRoute {
  FORM_PAGE = 'validate/:programId',
  LINK_USED = 'link-used',
  NOT_FOUND = 'invalid-link',
  EXPIRED = 'expired'
}
